import { Component, OnInit } from '@angular/core';
import { UscTableViewComponent } from '../usc-table-view/usc-table-view.component';

@Component({
    selector: 'sn-usc-p2w-detailed-results',
    templateUrl: '../usc-table-view/usc-table-view.component.html',
    styleUrls: ['../usc-table-view/usc-table-view.component.css']
})  

export class UscP2wDetailedResultsComponent extends UscTableViewComponent {

    ngOnInit() {
        this.view = this.uscStoreService.view_p2w_goal_gross_adds_detail_results;
        this.isPreviousMonthEnabled = false;
        this.enabled_include_todays_sales = false;

        // this.is_previous_month = this.current_month != this.uscStoreService.getThisMonthActionPlanSubject();
        // var current_user = this.authService.getActive();
        // this.available_months = this.uscStoreService.getAvailableActionPlanMonths(current_user);

        super.ngOnInit();
    }
    
    // filter(field, f) {
    //     field.current_filtered_value = (f.value == 'All' || f.value == '') ? null : f.value;
    //     this.curPage = 1;
    //     var current_user_scorecard = this.detail_items.find(i => i.CREATOR_ID == this.current_user.username);       // get associate info for filter initialization
    //     var cur_is_filtered_to_associate_store = this.is_filtered_to_associate_store;
    //     var store_filter = this.pageFilterFields.find(f => f.key == "store");
    //     this.is_filtered_to_associate_store = store_filter.current_filtered_value == current_user_scorecard.store;
    //     if (cur_is_filtered_to_associate_store != this.is_filtered_to_associate_store) {
    //         this.reloadItems(false);
    //     } else {
    //         this.updateDisplayDetailedItems();
    //     }
    // }

    updateDetailedResults(month:string) {
        this.current_month = month;
        this.is_current_month = this.current_month == this.uscStoreService.getThisMonthActionPlanSubject();
        this.is_previous_month = this.current_month != this.uscStoreService.getThisMonthActionPlanSubject();
        this.reloadItems();
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-mobile/usc-p2w-detailed-results/usc-p2w-detailed-results.component.ts